/* global axios */
import ApiClient from './ApiClient';
import { resourcePath, requestConfig, withQuery } from './lais/httpHelpers';

class PropertyMatchesAPI extends ApiClient {
  constructor() {
    super('property_matches', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(withQuery(this.url, params), requestConfig());
  }

  operationalSnapshot(params = {}) {
    return axios.get(
      withQuery(resourcePath(this.url, 'operational_snapshot'), params),
      requestConfig()
    );
  }
}

export default new PropertyMatchesAPI();
